// extracted by mini-css-extract-plugin
module.exports = {"input-layout":"customInput_input-layout__XTxti","input":"customInput_input__cin7_","active":"customInput_active__5B6wN","voice-layout":"customInput_voice-layout__0iFDj"};